export function getHighestZIndex(root)
{
    if ( typeof document === 'undefined' ) {
        return 0;
    }

    const container = root || document;
    const elements = container.getElementsByTagName('*');
    let highest = 0;

    for ( const el of elements ) {
        // Skip transient overlay elements (hover tooltips) so their
        // high z-index doesn't inflate the level assigned to modals.
        if ( el.hasAttribute('data-hover-over-tooltip') ) {
            continue;
        }

        const style = (el.ownerDocument?.defaultView || window).getComputedStyle(el);
        const z = parseInt(style.zIndex, 10);

        if ( !Number.isNaN(z) && z > highest ) {
            highest = z;
        }
    }

    return highest;
}

export function applyModalZIndex(modal, offset = 1)
{
    if ( !modal || typeof document === 'undefined' ) {
        return null;
    }

    const next = getHighestZIndex() + offset;
    modal.style.zIndex = String(next);
    return next;
}

export function initModalZIndex()
{
    if ( typeof window === 'undefined' ) {
        return;
    }

    if ( !window._getHighestZIndex ) {
        window._getHighestZIndex = getHighestZIndex;
    }

    if ( !window.__brtApplyModalZIndex ) {
        window.__brtApplyModalZIndex = applyModalZIndex;
    }
}
